const minLength = 8;
export const passwordRequirementsText = `Your password should include at least ${minLength} characters, an uppercase letter, a lowercase letter, and a number.`;

export function validatePassword(password: string): { error: string } {
  const hasUpperAndLowerAndNumber = /((?=.*[A-Z])(?=.*[a-z])(?=.*\d)).*/;
  if (password === '') {
    return { error: 'Required' };
  } else if (password.length < minLength) {
    return {
      error: `Oops! Password does not meet minimum length of ${minLength} characters.`,
    };
  } else if (!hasUpperAndLowerAndNumber.test(password)) {
    return {
      error:
        'Oops! Password does not contain all three categories: an uppercase letter, a lowercase letter, and a number.',
    };
  }
  return { error: '' };
}
